module.exports = __webpack_public_path__ + "static/img/OTTAWA_MAPLE.49874f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/OTTAWA_MAPLE.jpg
// module id = Qpc+
// module chunks = 0